import { Pipe, PipeTransform } from "@angular/core";
import { TimeFormatService } from "./time-format.service";

@Pipe({ name: "timeFormat" })
export class TimeFormatPipe implements PipeTransform {
  constructor(private timeFormatService: TimeFormatService) {}

  public transform(interval: any) {
    return this.timeFormatService.timeFor(interval);
  }
}
